import React from "react";

import Tooltip from "../Tooltip/Tooltip";

import { SelectionLabel } from "../DimensionSelect.styles";

const SelectBox = ({
  id,
  name, 
  description, 
  selectedValue, 
  handleSelect, 
  values, 
  language,
  renderCorrectionInformation
}) => (
  <div className="lfc-select-container">
    <SelectionLabel htmlFor={id}>{name}</SelectionLabel>

    {description && <Tooltip content={description} />}

    <select
      id={id}
      value={selectedValue}
      onChange={handleSelect}
    >
      {values.map(value => (
        <option
          key={"dv".concat(value.valueId.toString())}
          value={value.valueId}
          disabled={!value.selectable}
        >
          {value[`valueName${language}`]}
        </option>
      ))}
    </select>

    {renderCorrectionInformation && renderCorrectionInformation()}
  </div>
);

export default SelectBox;